<template>
  <div class="main-wrapper">
    <div>
      <!-- <layout-header2></layout-header2> -->
      <layout-header></layout-header>
      <breadcrumb5></breadcrumb5>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar2></sidebar2>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-else>
              <!-- <div>
                <h3 class="mb-3 mt-2">Reviews</h3>
              </div> -->
              <div class="doc-review review-listing ml-md-4" v-if="reviews.length">
                <!-- Review Listing -->
                <ul class="comments-list" id="patient_container">
                  <!-- Comment List -->
                  <li v-for="(item, index) in reviews" v-bind:key="index" v-show="setPaginate(index)">
                    <div class="comment">
                      <img class="avatar rounded-circle" alt="User Image" v-bind:src="item.image
                        ? config.base_url_for_Image + item.image
                        : loadImg('Patient Profile.svg')
                        " />
                      <div class="comment-body">
                        <div class="meta-data">
                          <span class="comment-author">{{
                            item.user_name ? item.user_name : "-"
                          }}</span>
                          <span class="comment-date">Reviewed {{ formatDate(item.published_on) }}</span>
                          <span style="font-size:15px;color:black;"> For {{item.doctor_name}}</span>
                          <div class="review-count rating">
                            <star-rating v-model="item.rating" :star-size="20" :max-rating="5" :show-rating="false"
                              read-only="true"></star-rating>
                          </div>
                        </div>
                        <p class="recommended">
                          <i class="far fa-thumbs-up"></i>
                          {{ item.review_title }}
                        </p>
                        <p class="comment-content">
                          {{ item.comment }}
                        </p>
                        <div class="comment-reply">
                          <!-- comment date of 23/8/23 start -->
                          <!-- <a class="comment-btn" href="#">
                            <i class="fas fa-reply"></i> Reply
                          </a> -->
                          <!-- comment date of 23/8/23 end-->
                          <!-- <p class="recommend-btn">
                            <span>Recommend?</span>
                            <a href="#" class="like-btn">
                              <i class="far fa-thumbs-up"></i> Yes
                            </a>
                            <a href="#" class="dislike-btn">
                              <i class="far fa-thumbs-down"></i> No
                            </a>
                          </p> -->
                        </div>
                      </div>
                    </div>
                  </li>
                  <!-- /Comment List -->
                </ul>

                <!-- /Comment List -->
              </div>
              <h5 v-if="reviews.length === 0 && !showspinner" style="margin-left: -8%" class="No_data">
                No Reviews Found
              </h5>
              <!-- pagination start -->
              <div id="pagination" v-if="reviews.length > 10">
                <ul class="pagination justify-content-center">

                  <!-- "Previous" Button -->
                  <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                    <a href="#" class="page-link" aria-label="Previous"
                      @click.prevent="updateInvestigationCount(current - 1)">
                      Previous
                    </a>
                  </li>

                  <!-- Pagination Links (Display 5 at a time) -->
                  <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                    'page-item',
                    current === page_index ? 'active' : ''
                  ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                    <a href="#" class="page-link" @click.prevent="updateInvestigationCount(page_index)">
                      {{ page_index }}
                    </a>
                  </li>

                  <!-- "Next" Button -->
                  <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                    ">
                    <a href="#" class="page-link" aria-label="Next"
                      @click.prevent="updateInvestigationCount(current + 1)">
                      Next
                    </a>
                  </li>
                </ul>
              </div>
              <!-- pagination end -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import patients from "../../../assets/json/doctor/mypatients.json";
import CommonApi from "../../../services/CommonApi";
import config from "../../../services/CommonApi";
import StarRating from "vue-star-rating";
const images = require.context("@/assets/img/patients");
export default {
  data() {
    return {
      patients: patients,
      showspinner: true,
      config: config,
      reviews: [],

      current: 1,
      paginate: 10,
      paginate_total: 0,
    };
  },
  components: { StarRating },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_portal_review();
  },
  methods: {

        //pagination start
        updateInvestigationCount(i) {
      this.current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },
    //pagination end


    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      // const year = date.getFullYear();
      const year = date.getFullYear().toString().slice(-2); 
      return `${day}-${month}-${year}`;
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },
    /* Get Doctor Reviews  */
    async get_portal_review() {
      const params = new URLSearchParams();
      params.append("hospital","Ramsnehi Hospital-Bhilwara");
      await CommonApi.get_data("sahaj.hospital.get_hospital_doctor_review", params).then(
        (res) => {
          this.showspinner = false;
          if (res && res.data && res.status_code == 200) {
            this.reviews = res.data;
            this.paginate_total = Math.ceil(
            this.reviews.length / this.paginate
          );
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/kneexpert/hospital/Reviews.vue